import styles from './Line.module.css'

export default function Line({color = "#757575",...rest}){
    return (

        <hr className={styles.line} style={{ borderTopColor: color }} {...rest}></hr>
    )
}